<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirm()"
  data-test="import-cropfields-failures"
>
  <div class="flex--row flex--gutter">
    <div class="flex__child--auto spacing--padding-all">
      {{
        'cropFieldSyncFailedDialog.description'
          | translate: { failedCount: data.failedCropFields.length.toString() }
      }}
    </div>
  </div>

  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>{{
        'cropFieldSyncFailedDialog.failedFieldsDropDownTitle' | translate
      }}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="flex--row flex--gutter">
      <mat-action-list class="flex__child--auto action-list">
        @for (item of data.failedCropFields; track item.cropField.id) {
          <mat-list-item
            class="failed-crop-field-item"
            [attr.data-test]="'failed-crop-field--' + item.cropField.id"
          >
            <div matListItemTitle>
              <span>{{ item.cropField.name }}</span>
            </div>
            <div matListItemLine>
              <span>{{ item.cropField.areaInHectares | number: '0.0-2' }} ha</span>
            </div>
            <div matListItemLine>
              <span
                >{{ item.cropField.startDate | date: 'shortDate' }} -
                {{ item.cropField.endDate | date: 'shortDate' }}</span
              >
            </div>
            <div matListItemLine>
              <span>{{ getCropName(item.cropField) }}</span>
            </div>
            <div matListItemLine class="error-message">
              <span>{{ getLocalisedErrorMessage(item.error, item.batchIndex) }}</span>
            </div>
          </mat-list-item>
        }
      </mat-action-list>
    </div>
  </mat-expansion-panel>
</agr-form-dialog>
